const toObject = require('convert-to-object')
import axios from 'axios'
import * as util from '../../util'

const callApi = async (serviceName) => {
    let url = util.getHttpRequestUrl(serviceName)
    try {
        let response = await axios.get(url)
        let data = convertStringToObj(response.data)
        util.logger(url)
        util.logger(data)
        return {
            status: true,
            data: data
        }
    } catch (err) {
        return {
            status: false,
            data: []
        }
    }
}

const convertStringToObj = (response) => {
    if (typeof response === 'string')
        response = toObject(response)
    return response
}

export default callApi